import { Helmet } from 'react-helmet-async';
import './landing-variants.css';

const metrics = [
  { label: 'Cabinets actifs', value: '240+' },
  { label: 'Rendez-vous/mois', value: '61k' },
  { label: 'Temps gagné', value: '34%' },
];

const features = [
  {
    num: '01',
    title: 'Agenda intelligent',
    desc: 'Optimisation automatique des créneaux. Confirmations SMS. Zéro trou dans votre planning.',
    accent: 'var(--doctif-coral)',
  },
  {
    num: '02',
    title: 'Dossiers patients',
    desc: 'Historique clinique complet, radios et notes — accessible en un geste depuis le fauteuil.',
    accent: '#2563eb',
  },
  {
    num: '03',
    title: 'Facturation fluide',
    desc: 'Devis, factures et relances automatiques — tout se gère sans quitter votre flux clinique.',
    accent: '#059669',
  },
  {
    num: '04',
    title: 'Multi-cabinet',
    desc: 'Pilotez plusieurs sites depuis un tableau de bord unifié, en temps réel.',
    accent: '#7c3aed',
  },
];

const workflow = [
  {
    step: '1',
    title: 'Réservation',
    desc: 'Le patient choisit son créneau en ligne. Formulaire pré-rempli, confirmation instantanée.',
    icon: '📅',
  },
  {
    step: '2',
    title: 'Consultation',
    desc: 'Checklist interactive au fauteuil. Notes, photos et actes codifiés en direct.',
    icon: '🦷',
  },
  {
    step: '3',
    title: 'Suivi',
    desc: 'Facture générée, relance programmée, synthèse quotidienne envoyée au praticien.',
    icon: '✉️',
  },
];

export default function LandingV5() {
  return (
    <div
      className="doctif-page"
      style={{
        fontFamily: 'Manrope, sans-serif',
        background:
          'radial-gradient(circle at 12% 16%, #ffd6bf 0, transparent 26%), radial-gradient(circle at 88% 14%, #d6e8ff 0, transparent 24%), var(--doctif-cream)',
        color: 'var(--doctif-ink)',
      }}
    >
      <Helmet>
        <title>doctif — Suite clinique premium</title>
      </Helmet>

      {/* ── Header ── */}
      <header className="doctif-shell" style={{ padding: '26px 0 18px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 16 }}>
          <div style={{ fontFamily: 'Bodoni Moda, serif', fontSize: 34, lineHeight: 1 }}>doctif</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <nav className="doctif-chip-row">
              <a className="doctif-chip" href="/1" style={{ background: '#e9e2d2', color: '#1f2937' }}>V1</a>
              <a className="doctif-chip" href="/2" style={{ background: '#e9e2d2', color: '#1f2937' }}>V2</a>
              <a className="doctif-chip" href="/3" style={{ background: '#e9e2d2', color: '#1f2937' }}>V3</a>
              <a className="doctif-chip" href="/4" style={{ background: '#e9e2d2', color: '#1f2937' }}>V4</a>
              <a className="doctif-chip" href="/5" style={{ background: '#1f2937', color: '#fff' }}>V5</a>
            </nav>
            <a href="/accounts/login/" style={{
              color: 'var(--doctif-coral)', textDecoration: 'none', fontWeight: 700, fontSize: 14,
              padding: '8px 18px', border: '1px solid #c4572f44', borderRadius: 999,
              transition: 'all 0.3s',
            }}>Connexion</a>
          </div>
        </div>
      </header>

      {/* ── Hero ── */}
      <main className="doctif-shell" style={{ display: 'grid', gridTemplateColumns: '1.15fr 0.85fr', gap: 28, alignItems: 'start', paddingBottom: 36 }}>
        <section>
          <p className="doctif-kicker doctif-fade-up" style={{ color: '#92400e' }}>Suite de gestion pour cabinets dentaires</p>
          <h1
            className="doctif-fade-up doctif-delay-1"
            style={{
              fontFamily: 'Bodoni Moda, serif',
              fontWeight: 700,
              fontSize: 'clamp(2.2rem, 6vw, 4.5rem)',
              lineHeight: 1.02,
              marginTop: 14,
              marginBottom: 18,
            }}
          >
            Une interface signature
            <br />
            pour les cabinets exigeants.
          </h1>

          <p className="doctif-fade-up doctif-delay-2" style={{ maxWidth: 620, fontSize: 18, lineHeight: 1.6, color: '#374151' }}>
            doctif coordonne les rendez-vous, les dossiers patients et la facturation dans un flux unique.
            Le design est volontairement éditorial: clair, premium et mémorisable.
          </p>

          <div className="doctif-fade-up doctif-delay-3" style={{ display: 'flex', gap: 12, marginTop: 24, flexWrap: 'wrap' }}>
            <a
              href="/accounts/login/"
              style={{
                background: 'var(--doctif-coral)',
                color: '#fff',
                borderRadius: 999,
                padding: '12px 20px',
                fontWeight: 800,
                textDecoration: 'none',
                transition: 'transform 0.2s, box-shadow 0.2s',
                boxShadow: '0 6px 24px rgba(196,87,47,0.25)',
              }}
            >
              Commencer avec doctif
            </a>
            <a
              href="/booking"
              style={{
                border: '1px solid #9ca3af',
                color: '#1f2937',
                borderRadius: 999,
                padding: '12px 20px',
                fontWeight: 800,
                textDecoration: 'none',
                background: '#fff',
              }}
            >
              Voir le parcours patient
            </a>
          </div>

          <div
            className="doctif-fade-up doctif-delay-4"
            style={{
              marginTop: 26,
              display: 'grid',
              gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
              gap: 10,
            }}
          >
            {metrics.map((metric) => (
              <article key={metric.label} style={{ background: '#fff', borderRadius: 16, padding: 14, border: '1px solid #e5e7eb' }}>
                <div style={{ fontSize: 25, fontWeight: 800 }}>{metric.value}</div>
                <div style={{ fontSize: 13, color: '#4b5563' }}>{metric.label}</div>
              </article>
            ))}
          </div>
        </section>

        <section
          className="doctif-fade-up doctif-delay-3"
          style={{
            borderRadius: 24,
            border: '1px solid #e5e7eb',
            background: 'linear-gradient(165deg, #ffffff, #f3f4f6)',
            padding: 18,
            boxShadow: '0 22px 45px -30px rgba(31,41,55,0.6)',
          }}
        >
          <div style={{ borderRadius: 18, background: '#111827', color: '#f9fafb', padding: 18 }}>
            <p className="doctif-kicker" style={{ color: '#9ca3af' }}>TABLEAU DE FLUX</p>
            <h2 style={{ fontFamily: 'Bodoni Moda, serif', fontSize: 28, marginTop: 8, marginBottom: 14 }}>Journée clinique</h2>
            <div style={{ display: 'grid', gap: 10 }}>
              {[
                ['08:30', 'Premier patient confirmé'],
                ['10:00', 'Dossier numérique complété'],
                ['13:15', 'Facture envoyée automatiquement'],
                ['17:40', 'Relance SMS des rendez-vous'],
              ].map(([time, label]) => (
                <div key={time} style={{ display: 'flex', justifyContent: 'space-between', gap: 8, padding: '9px 0', borderBottom: '1px solid #374151' }}>
                  <span style={{ color: '#fbbf24', fontWeight: 700 }}>{time}</span>
                  <span>{label}</span>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      {/* ── Divider with coral accent ── */}
      <div style={{ height: 1, background: 'linear-gradient(90deg, transparent 5%, #c4572f33 50%, transparent 95%)' }} />

      {/* ── Features Section ── */}
      <section className="doctif-shell" style={{ padding: '80px 0 60px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 48, flexWrap: 'wrap', gap: 20 }}>
          <div>
            <p className="doctif-kicker doctif-fade-up" style={{ color: '#92400e', marginBottom: 12 }}>Les fondamentaux</p>
            <h2 className="doctif-fade-up doctif-delay-1" style={{
              fontFamily: 'Bodoni Moda, serif',
              fontSize: 'clamp(1.8rem, 4vw, 3.2rem)',
              fontWeight: 700,
              lineHeight: 1.05,
            }}>
              Quatre modules,
              <br /><span style={{ color: 'var(--doctif-coral)' }}>un seul flux.</span>
            </h2>
          </div>
          <p className="doctif-fade-up doctif-delay-2" style={{ color: '#6b7280', fontSize: 15, maxWidth: 320, lineHeight: 1.6 }}>
            Chaque module est conçu pour s'intégrer sans friction dans votre journée clinique.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: 16,
        }}>
          {features.map((f, i) => (
            <article
              key={f.num}
              className={`doctif-fade-up doctif-delay-${Math.min(i + 1, 4)}`}
              style={{
                background: '#fff',
                border: '1px solid #e5e7eb',
                borderRadius: 20,
                padding: '28px 26px',
                marginTop: i === 1 || i === 3 ? 24 : 0,
                transition: 'border-color 0.3s, box-shadow 0.3s, transform 0.2s',
                cursor: 'default',
                position: 'relative',
                overflow: 'hidden',
              }}
              onMouseEnter={e => {
                const el = e.currentTarget as HTMLElement;
                el.style.borderColor = f.accent;
                el.style.boxShadow = `0 16px 40px -16px ${f.accent}33`;
                el.style.transform = 'translateY(-3px)';
              }}
              onMouseLeave={e => {
                const el = e.currentTarget as HTMLElement;
                el.style.borderColor = '#e5e7eb';
                el.style.boxShadow = 'none';
                el.style.transform = 'translateY(0)';
              }}
            >
              {/* Subtle top line accent */}
              <div aria-hidden style={{
                position: 'absolute', top: 0, left: 0, right: 0,
                height: 3, background: f.accent, opacity: 0.5,
                borderRadius: '20px 20px 0 0',
              }} />
              <div style={{
                fontFamily: 'Bodoni Moda, serif',
                fontSize: 44,
                color: f.accent + '22',
                lineHeight: 1,
                marginBottom: 14,
              }}>{f.num}</div>
              <h3 style={{
                fontFamily: 'Bodoni Moda, serif',
                fontSize: 22,
                fontWeight: 700,
                marginBottom: 10,
              }}>{f.title}</h3>
              <p style={{ color: '#6b7280', lineHeight: 1.65, fontSize: 15 }}>{f.desc}</p>
            </article>
          ))}
        </div>
      </section>

      {/* ── Dashboard Preview ── */}
      <section className="doctif-shell" style={{ paddingBottom: 80 }}>
        <div style={{
          borderRadius: 24,
          border: '1px solid #e5e7eb',
          background: 'linear-gradient(165deg, #fff, #faf8f5)',
          padding: 28,
          boxShadow: '0 30px 60px -20px rgba(31,41,55,0.12)',
        }}>
          {/* Preview header */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 22 }}>
            <div>
              <p style={{ fontSize: 11, color: '#9ca3af', letterSpacing: '0.15em', textTransform: 'uppercase', fontWeight: 700 }}>Aperçu du jour</p>
              <h3 style={{ fontFamily: 'Bodoni Moda, serif', fontSize: 28, marginTop: 4 }}>Mardi 25 Mars</h3>
            </div>
            <div style={{ display: 'flex', gap: 8 }}>
              {['Agenda', 'Patients', 'Factures'].map((tab, i) => (
                <span key={tab} style={{
                  padding: '6px 14px', borderRadius: 999, fontSize: 13, fontWeight: 700,
                  background: i === 0 ? 'var(--doctif-coral)' : '#f3f4f6',
                  color: i === 0 ? '#fff' : '#6b7280',
                  border: i === 0 ? 'none' : '1px solid #e5e7eb',
                }}>{tab}</span>
              ))}
            </div>
          </div>

          {/* Appointment cards */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
            {[
              { time: '08:30', patient: 'M. Benali', type: 'Contrôle', accent: 'var(--doctif-coral)' },
              { time: '09:15', patient: 'Mme. Idrissi', type: 'Détartrage', accent: '#059669' },
              { time: '10:00', patient: 'M. Lahlou', type: 'Prothèse', accent: '#2563eb' },
            ].map(appt => (
              <div key={appt.time} style={{
                background: '#faf8f5', borderRadius: 16, padding: '16px 14px',
                borderLeft: `3px solid ${appt.accent}`,
                border: '1px solid #e5e7eb',
                borderLeftWidth: 3,
                borderLeftColor: appt.accent,
              }}>
                <div style={{ color: 'var(--doctif-coral)', fontWeight: 700, fontSize: 13, marginBottom: 6 }}>{appt.time}</div>
                <div style={{ fontWeight: 700, fontSize: 15 }}>{appt.patient}</div>
                <div style={{ color: '#9ca3af', fontSize: 13, marginTop: 2 }}>{appt.type}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Workflow / How It Works ── */}
      <section style={{ background: '#111827', color: '#f9fafb', position: 'relative', overflow: 'hidden' }}>
        {/* Subtle radial accent */}
        <div aria-hidden style={{
          position: 'absolute', width: 400, height: 400,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(196,87,47,0.12), transparent 70%)',
          top: -100, right: -100,
        }} />
        <div className="doctif-shell" style={{ padding: '80px 0', position: 'relative', zIndex: 1 }}>
          <div style={{ textAlign: 'center', marginBottom: 56 }}>
            <p className="doctif-kicker" style={{ color: '#fbbf24', marginBottom: 14 }}>Comment ça marche</p>
            <h2 style={{
              fontFamily: 'Bodoni Moda, serif',
              fontSize: 'clamp(1.8rem, 4.5vw, 3rem)',
              fontWeight: 700,
              lineHeight: 1.08,
            }}>
              Du rendez-vous
              <br /> à la <span style={{ color: 'var(--doctif-coral)' }}>facturation.</span>
            </h2>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: 20,
          }}>
            {workflow.map((w, i) => (
              <div key={w.step} style={{
                background: 'rgba(255,255,255,0.04)',
                border: '1px solid #374151',
                borderRadius: 22,
                padding: '32px 24px',
                textAlign: 'center',
                transition: 'border-color 0.3s, transform 0.2s',
                cursor: 'default',
              }}
                onMouseEnter={e => {
                  (e.currentTarget as HTMLElement).style.borderColor = '#c4572f';
                  (e.currentTarget as HTMLElement).style.transform = 'translateY(-4px)';
                }}
                onMouseLeave={e => {
                  (e.currentTarget as HTMLElement).style.borderColor = '#374151';
                  (e.currentTarget as HTMLElement).style.transform = 'translateY(0)';
                }}
              >
                <div style={{ fontSize: 36, marginBottom: 14 }}>{w.icon}</div>
                <div style={{
                  fontFamily: 'Bodoni Moda, serif',
                  fontSize: 14,
                  color: '#fbbf24',
                  letterSpacing: '0.1em',
                  marginBottom: 8,
                }}>ÉTAPE {w.step}</div>
                <h3 style={{
                  fontFamily: 'Bodoni Moda, serif',
                  fontSize: 24,
                  fontWeight: 700,
                  marginBottom: 12,
                }}>{w.title}</h3>
                <p style={{ color: '#9ca3af', fontSize: 14, lineHeight: 1.6 }}>{w.desc}</p>
                {i < 2 && (
                  <div aria-hidden style={{
                    position: 'absolute',
                    right: -10,
                    top: '50%',
                    color: '#374151',
                    fontSize: 20,
                  }}>→</div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Testimonials ── */}
      <section className="doctif-shell" style={{ padding: '80px 0 60px' }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <p className="doctif-kicker" style={{ color: '#92400e', marginBottom: 12 }}>Témoignages</p>
          <h2 style={{
            fontFamily: 'Bodoni Moda, serif',
            fontSize: 'clamp(1.6rem, 4vw, 2.8rem)',
            fontWeight: 700,
          }}>
            Ce que disent <span style={{ color: 'var(--doctif-coral)' }}>nos praticiens.</span>
          </h2>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: 20,
        }}>
          {[
            {
              quote: "On a réduit notre temps administratif de 40%. L'équipe ne veut plus revenir en arrière.",
              name: 'Dr. Khalil',
              clinic: 'Cabinet Dentaire Al Madina — Casablanca',
              initials: 'DK',
              bg: 'linear-gradient(135deg, #c4572f, #92400e)',
            },
            {
              quote: "La vue multi-cabinet a changé notre façon de piloter. Tout est là, en temps réel.",
              name: 'Dr. Brahmi',
              clinic: 'Clinique Dentaire Corbei — Oujda',
              initials: 'SB',
              bg: 'linear-gradient(135deg, #059669, #047857)',
            },
          ].map(t => (
            <div key={t.name} style={{
              background: '#fff',
              border: '1px solid #e5e7eb',
              borderRadius: 22,
              padding: '28px 26px',
              transition: 'box-shadow 0.3s',
            }}
              onMouseEnter={e => (e.currentTarget.style.boxShadow = '0 20px 50px -20px rgba(31,41,55,0.15)')}
              onMouseLeave={e => (e.currentTarget.style.boxShadow = 'none')}
            >
              {/* Stars */}
              <div style={{ marginBottom: 14, color: '#fbbf24', fontSize: 18, letterSpacing: 2 }}>★★★★★</div>
              <blockquote style={{
                fontFamily: 'Bodoni Moda, serif',
                fontSize: 20,
                fontWeight: 500,
                lineHeight: 1.4,
                margin: 0,
                marginBottom: 20,
                fontStyle: 'italic',
              }}>
                "{t.quote}"
              </blockquote>
              <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                <div style={{
                  width: 42, height: 42, borderRadius: '50%',
                  background: t.bg,
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 15, fontWeight: 800, color: '#fff',
                }}>{t.initials}</div>
                <div>
                  <div style={{ fontWeight: 800, fontSize: 15 }}>{t.name}</div>
                  <div style={{ color: '#9ca3af', fontSize: 13 }}>{t.clinic}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* ── Pricing / Trust Banner ── */}
      <section style={{
        background: 'linear-gradient(165deg, var(--doctif-cream) 0%, #fef3c7 50%, var(--doctif-cream) 100%)',
        borderTop: '1px solid #e5e7eb',
        borderBottom: '1px solid #e5e7eb',
      }}>
        <div className="doctif-shell" style={{
          padding: '48px 0',
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: 20,
          textAlign: 'center',
        }}>
          {[
            { icon: '🔒', title: 'Données chiffrées', desc: 'AES-256 en transit et au repos' },
            { icon: '🇲🇦', title: 'Hébergé au Maroc', desc: 'Conformité locale garantie' },
            { icon: '⚡', title: 'Temps réel', desc: 'Synchronisation < 1 seconde' },
            { icon: '🎧', title: 'Support dédié', desc: 'Réponse sous 2h ouvrées' },
          ].map(t => (
            <div key={t.title} style={{ padding: '12px 8px' }}>
              <div style={{ fontSize: 28, marginBottom: 10 }}>{t.icon}</div>
              <div style={{ fontWeight: 800, fontSize: 15, marginBottom: 4 }}>{t.title}</div>
              <div style={{ color: '#6b7280', fontSize: 13 }}>{t.desc}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="doctif-shell" style={{ padding: '80px 0', textAlign: 'center' }}>
        <h2 style={{
          fontFamily: 'Bodoni Moda, serif',
          fontSize: 'clamp(2rem, 5vw, 3.5rem)',
          fontWeight: 700,
          marginBottom: 16,
          lineHeight: 1.05,
        }}>
          Prêt à <span style={{ color: 'var(--doctif-coral)' }}>élever</span>
          <br />votre pratique ?
        </h2>
        <p style={{ color: '#6b7280', maxWidth: 480, margin: '0 auto 32px', lineHeight: 1.65, fontSize: 16 }}>
          Rejoignez les praticiens qui ont choisi l'exigence.
          <br />Sans engagement, sans carte bancaire.
        </p>
        <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
          <a href="/accounts/login/" style={{
            display: 'inline-flex', alignItems: 'center', gap: 10,
            background: 'var(--doctif-coral)', color: '#fff', padding: '16px 32px',
            borderRadius: 999, fontWeight: 800, fontSize: 16, textDecoration: 'none',
            boxShadow: '0 10px 40px rgba(196,87,47,0.3)',
            transition: 'transform 0.2s, box-shadow 0.2s',
          }}>
            Démarrer avec doctif <span style={{ fontSize: 20 }}>→</span>
          </a>
          <a href="/booking" style={{
            display: 'inline-flex', alignItems: 'center', gap: 8,
            background: '#fff', color: 'var(--doctif-ink)', padding: '16px 28px',
            borderRadius: 999, fontWeight: 700, fontSize: 16, textDecoration: 'none',
            border: '1px solid #d1d5db',
            transition: 'border-color 0.3s',
          }}>
            Voir la démo
          </a>
        </div>
      </section>

      {/* ── Footer ── */}
      <footer style={{ borderTop: '1px solid #e5e7eb' }}>
        <div className="doctif-shell" style={{
          padding: '28px 0',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span style={{ fontFamily: 'Bodoni Moda, serif', fontSize: 22, color: '#9ca3af' }}>doctif</span>
            <span style={{ color: '#d1d5db' }}>|</span>
            <span style={{ color: '#9ca3af', fontSize: 12 }}>Direction éditorial premium — Version 05</span>
          </div>
          <div style={{ display: 'flex', gap: 24 }}>
            {['Confidentialité', 'CGU', 'Contact'].map(link => (
              <a key={link} href="#" style={{ color: '#9ca3af', fontSize: 12, textDecoration: 'none', fontWeight: 600, transition: 'color 0.2s' }}
                onMouseEnter={e => (e.currentTarget.style.color = 'var(--doctif-coral)')}
                onMouseLeave={e => (e.currentTarget.style.color = '#9ca3af')}
              >{link}</a>
            ))}
          </div>
        </div>
      </footer>

      {/* Responsive overrides */}
      <style>{`
        @media (max-width: 980px) {
          main.doctif-shell { grid-template-columns: 1fr !important; }
        }
        @media (max-width: 768px) {
          .doctif-shell > div[style*='grid-template-columns: repeat(4'] { grid-template-columns: repeat(2, 1fr) !important; }
          .doctif-shell > div[style*='grid-template-columns: repeat(2'] { grid-template-columns: 1fr !important; }
          .doctif-shell > div[style*='grid-template-columns: repeat(3'] { grid-template-columns: 1fr !important; }
          .doctif-shell > div[style*='grid-template-columns: 1fr 1fr'] { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </div>
  );
}
